import { DepartureInventoryResponse } from '~/types/tours/inventory';

import { request } from './common';
import { OkResponse, toursBasePath } from './toursApi';

/**
 * The inventory held against one departure of a supplier service: what has been
 * sold, on which package option, and the ledger entry behind each unit.
 * `departureId` must be the package departure ID supplied by the departures form.
 */
export async function getDepartureInventory(
  { serviceId, departureId }: { serviceId: string; departureId: string },
  options?: { signal?: AbortSignal },
): Promise<DepartureInventoryResponse> {
  const response: OkResponse<DepartureInventoryResponse> = await request(
    `${toursBasePath()}/services/${serviceId}/departures/${departureId}/inventory`,
    { method: 'GET', signal: options?.signal },
  );

  return response.result;
}
